const admin_search_filters = [
    {'id': 'title', 'name': 'Title'},
    {'id': 'organizer', 'name': 'Organizer'},
    {'id': 'date', 'name': 'Date'},
    {'id': 'type', 'name': 'Type'},
    {'id': 'category', 'name': 'Category'},
    {'id': 'status', 'name': 'Status'},
]

const client_search_filters = [
   {'id': 'title', 'name': 'Title'},
   {'id': 'content', 'name': 'Content'},
   {'id': 'organizer', 'name': 'Organizer'},
   {'id': 'date', 'name': 'Date'},
   {'id': 'type', 'name': 'Type'},
   {'id': 'category', 'name': 'Category'},
]

const event_status = [
    {'id': 'active', 'name': 'Active'},
    {'id': 'draft', 'name': 'Draft'},
    {'id': 'postponed', 'name': 'Postponed'},
    {'id': 'cancelled', 'name': 'Cancelled'},
    {'id': 'completed', 'name': 'Completed'},
]

const payment_status = [
    {'id': 2, 'name': 'Pending'},
    {'id': 3, 'name': 'Failed'},
    {'id': 4, 'name': 'Success'},
]

const payment_methods = [
    {'id': 1, 'name': 'Credit Card (Pesopay)'},
    {'id': 2, 'name': 'Paypal'},
    {'id': 3, 'name': 'Others/bank'},
    {'id': 4, 'name': 'Gcash'},
   //  {'id': 5, 'name': 'Credit Card (Paynamics - under development)'},
]

const timezones = [
    {
       "value": '-12',
       "text": "(GMT -12:00) Eniwetok, Kwajalein"
    },
    {
       "value": '-11',
       "text": "(GMT -11:00) Midway Island, Samoa"
    },
    {
       "value": '-10',
       "text": "(GMT -10:00) Hawaii"
    },
    {
       "value": '-9',
       "text": "(GMT -9:00) Alaska"
    },
    {
       "value": '-8',
       "text": "(GMT -8:00) Pacific Time (US & Canada)"
    },
    {
       "value": '-7',
       "text": "(GMT -7:00) Mountain Time (US & Canada)"
    },
    {
       "value": '-6',
       "text": "(GMT -6:00) Central Time (US & Canada), Mexico City"
    },
    {
       "value": '-5',
       "text": "(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima"
    },
    {
       "value": '-4',
       "text": "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz"
    },
    {
       "value": '-3.5',
       "text": "(GMT -3:30) Newfoundland"
    },
    {
       "value": '-3',
       "text": "(GMT -3:00) Brazil, Buenos Aires, Georgetown"
    },
    {
       "value": '-2',
       "text": "(GMT -2:00) Mid-Atlantic"
    },
    {
       "value": '-1',
       "text": "(GMT -1:00) Azores, Cape Verde Islands"
    },
    {
       "value": 0,
       "text": "(GMT) Western Europe Time, London, Lisbon, Casablanca"
    },
    {
       "value": '+1',
       "text": "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris"
    },
    {
       "value": '+2',
       "text": "(GMT +2:00) Kaliningrad, South Africa"
    },
    {
       "value": '+3',
       "text": "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg"
    },
    {
       "value": '+3.5',
       "text": "(GMT +3:30) Tehran"
    },
    {
       "value": '+4',
       "text": "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi"
    },
    {
       "value": '4.5',
       "text": "(GMT +4:30) Kabul"
    },
    {
       "value": '5',
       "text": "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent"
    },
    {
       "value": '+5.5',
       "text": "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi"
    },
    {
       "value": '+5.75',
       "text": "(GMT +5:45) Kathmandu"
    },
    {
       "value": '+6',
       "text": "(GMT +6:00) Almaty, Dhaka, Colombo"
    },
    {
       "value": '+7',
       "text": "(GMT +7:00) Bangkok, Hanoi, Jakarta"
    },
    {
       "value": '+8',
       "text": "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong"
    },
    {
       "value": '+9',
       "text": "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk"
    },
    {
       "value": '+9.5',
       "text": "(GMT +9:30) Adelaide, Darwin"
    },
    {
       "value": '+10',
       "text": "(GMT +10:00) Eastern Australia, Guam, Vladivostok"
    },
    {
       "value": '+11',
       "text": "(GMT +11:00) Magadan, Solomon Islands, New Caledonia"
    },
    {
       "value": '+12',
       "text": "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka"
    }
 ]

 const countries = [ 
   {name: 'Afghanistan', code: 'AF'}, 
   {name: 'Åland Islands', code: 'AX'}, 
   {name: 'Albania', code: 'AL'}, 
   {name: 'Algeria', code: 'DZ'}, 
   {name: 'American Samoa', code: 'AS'}, 
   {name: 'AndorrA', code: 'AD'}, 
   {name: 'Angola', code: 'AO'}, 
   {name: 'Anguilla', code: 'AI'}, 
   {name: 'Antarctica', code: 'AQ'}, 
   {name: 'Antigua and Barbuda', code: 'AG'}, 
   {name: 'Argentina', code: 'AR'}, 
   {name: 'Armenia', code: 'AM'}, 
   {name: 'Aruba', code: 'AW'}, 
   {name: 'Australia', code: 'AU'}, 
   {name: 'Austria', code: 'AT'}, 
   {name: 'Azerbaijan', code: 'AZ'}, 
   {name: 'Bahamas', code: 'BS'}, 
   {name: 'Bahrain', code: 'BH'}, 
   {name: 'Bangladesh', code: 'BD'}, 
   {name: 'Barbados', code: 'BB'}, 
   {name: 'Belarus', code: 'BY'}, 
   {name: 'Belgium', code: 'BE'}, 
   {name: 'Belize', code: 'BZ'}, 
   {name: 'Benin', code: 'BJ'}, 
   {name: 'Bermuda', code: 'BM'}, 
   {name: 'Bhutan', code: 'BT'}, 
   {name: 'Bolivia', code: 'BO'}, 
   {name: 'Bosnia and Herzegovina', code: 'BA'}, 
   {name: 'Botswana', code: 'BW'}, 
   {name: 'Bouvet Island', code: 'BV'}, 
   {name: 'Brazil', code: 'BR'}, 
   {name: 'British Indian Ocean Territory', code: 'IO'}, 
   {name: 'Brunei Darussalam', code: 'BN'}, 
   {name: 'Bulgaria', code: 'BG'}, 
   {name: 'Burkina Faso', code: 'BF'}, 
   {name: 'Burundi', code: 'BI'}, 
   {name: 'Cambodia', code: 'KH'}, 
   {name: 'Cameroon', code: 'CM'}, 
   {name: 'Canada', code: 'CA'}, 
   {name: 'Cape Verde', code: 'CV'}, 
   {name: 'Cayman Islands', code: 'KY'}, 
   {name: 'Central African Republic', code: 'CF'}, 
   {name: 'Chad', code: 'TD'}, 
   {name: 'Chile', code: 'CL'}, 
   {name: 'China', code: 'CN'}, 
   {name: 'Christmas Island', code: 'CX'}, 
   {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
   {name: 'Colombia', code: 'CO'}, 
   {name: 'Comoros', code: 'KM'}, 
   {name: 'Congo', code: 'CG'}, 
   {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
   {name: 'Cook Islands', code: 'CK'}, 
   {name: 'Costa Rica', code: 'CR'}, 
   {name: 'Cote D\'Ivoire', code: 'CI'}, 
   {name: 'Croatia', code: 'HR'}, 
   {name: 'Cuba', code: 'CU'}, 
   {name: 'Cyprus', code: 'CY'}, 
   {name: 'Czech Republic', code: 'CZ'}, 
   {name: 'Denmark', code: 'DK'}, 
   {name: 'Djibouti', code: 'DJ'}, 
   {name: 'Dominica', code: 'DM'}, 
   {name: 'Dominican Republic', code: 'DO'}, 
   {name: 'Ecuador', code: 'EC'}, 
   {name: 'Egypt', code: 'EG'}, 
   {name: 'El Salvador', code: 'SV'}, 
   {name: 'Equatorial Guinea', code: 'GQ'}, 
   {name: 'Eritrea', code: 'ER'}, 
   {name: 'Estonia', code: 'EE'}, 
   {name: 'Ethiopia', code: 'ET'}, 
   {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
   {name: 'Faroe Islands', code: 'FO'}, 
   {name: 'Fiji', code: 'FJ'}, 
   {name: 'Finland', code: 'FI'}, 
   {name: 'France', code: 'FR'}, 
   {name: 'French Guiana', code: 'GF'}, 
   {name: 'French Polynesia', code: 'PF'}, 
   {name: 'French Southern Territories', code: 'TF'}, 
   {name: 'Gabon', code: 'GA'}, 
   {name: 'Gambia', code: 'GM'}, 
   {name: 'Georgia', code: 'GE'}, 
   {name: 'Germany', code: 'DE'}, 
   {name: 'Ghana', code: 'GH'}, 
   {name: 'Gibraltar', code: 'GI'}, 
   {name: 'Greece', code: 'GR'}, 
   {name: 'Greenland', code: 'GL'}, 
   {name: 'Grenada', code: 'GD'}, 
   {name: 'Guadeloupe', code: 'GP'}, 
   {name: 'Guam', code: 'GU'}, 
   {name: 'Guatemala', code: 'GT'}, 
   {name: 'Guernsey', code: 'GG'}, 
   {name: 'Guinea', code: 'GN'}, 
   {name: 'Guinea-Bissau', code: 'GW'}, 
   {name: 'Guyana', code: 'GY'}, 
   {name: 'Haiti', code: 'HT'}, 
   {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
   {name: 'Holy See (Vatican City State)', code: 'VA'}, 
   {name: 'Honduras', code: 'HN'}, 
   {name: 'Hong Kong', code: 'HK'}, 
   {name: 'Hungary', code: 'HU'}, 
   {name: 'Iceland', code: 'IS'}, 
   {name: 'India', code: 'IN'}, 
   {name: 'Indonesia', code: 'ID'}, 
   {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
   {name: 'Iraq', code: 'IQ'}, 
   {name: 'Ireland', code: 'IE'}, 
   {name: 'Isle of Man', code: 'IM'}, 
   {name: 'Israel', code: 'IL'}, 
   {name: 'Italy', code: 'IT'}, 
   {name: 'Jamaica', code: 'JM'}, 
   {name: 'Japan', code: 'JP'}, 
   {name: 'Jersey', code: 'JE'}, 
   {name: 'Jordan', code: 'JO'}, 
   {name: 'Kazakhstan', code: 'KZ'}, 
   {name: 'Kenya', code: 'KE'}, 
   {name: 'Kiribati', code: 'KI'}, 
   {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
   {name: 'Korea, Republic of', code: 'KR'}, 
   {name: 'Kuwait', code: 'KW'}, 
   {name: 'Kyrgyzstan', code: 'KG'}, 
   {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
   {name: 'Latvia', code: 'LV'}, 
   {name: 'Lebanon', code: 'LB'}, 
   {name: 'Lesotho', code: 'LS'}, 
   {name: 'Liberia', code: 'LR'}, 
   {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
   {name: 'Liechtenstein', code: 'LI'}, 
   {name: 'Lithuania', code: 'LT'}, 
   {name: 'Luxembourg', code: 'LU'}, 
   {name: 'Macao', code: 'MO'}, 
   {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
   {name: 'Madagascar', code: 'MG'}, 
   {name: 'Malawi', code: 'MW'}, 
   {name: 'Malaysia', code: 'MY'}, 
   {name: 'Maldives', code: 'MV'}, 
   {name: 'Mali', code: 'ML'}, 
   {name: 'Malta', code: 'MT'}, 
   {name: 'Marshall Islands', code: 'MH'}, 
   {name: 'Martinique', code: 'MQ'}, 
   {name: 'Mauritania', code: 'MR'}, 
   {name: 'Mauritius', code: 'MU'}, 
   {name: 'Mayotte', code: 'YT'}, 
   {name: 'Mexico', code: 'MX'}, 
   {name: 'Micronesia, Federated States of', code: 'FM'}, 
   {name: 'Moldova, Republic of', code: 'MD'}, 
   {name: 'Monaco', code: 'MC'}, 
   {name: 'Mongolia', code: 'MN'}, 
   {name: 'Montserrat', code: 'MS'}, 
   {name: 'Morocco', code: 'MA'}, 
   {name: 'Mozambique', code: 'MZ'}, 
   {name: 'Myanmar', code: 'MM'}, 
   {name: 'Namibia', code: 'NA'}, 
   {name: 'Nauru', code: 'NR'}, 
   {name: 'Nepal', code: 'NP'}, 
   {name: 'Netherlands', code: 'NL'}, 
   {name: 'Netherlands Antilles', code: 'AN'}, 
   {name: 'New Caledonia', code: 'NC'}, 
   {name: 'New Zealand', code: 'NZ'}, 
   {name: 'Nicaragua', code: 'NI'}, 
   {name: 'Niger', code: 'NE'}, 
   {name: 'Nigeria', code: 'NG'}, 
   {name: 'Niue', code: 'NU'}, 
   {name: 'Norfolk Island', code: 'NF'}, 
   {name: 'Northern Mariana Islands', code: 'MP'}, 
   {name: 'Norway', code: 'NO'}, 
   {name: 'Oman', code: 'OM'}, 
   {name: 'Pakistan', code: 'PK'}, 
   {name: 'Palau', code: 'PW'}, 
   {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
   {name: 'Panama', code: 'PA'}, 
   {name: 'Papua New Guinea', code: 'PG'}, 
   {name: 'Paraguay', code: 'PY'}, 
   {name: 'Peru', code: 'PE'}, 
   {name: 'Philippines', code: 'PH'}, 
   {name: 'Pitcairn', code: 'PN'}, 
   {name: 'Poland', code: 'PL'}, 
   {name: 'Portugal', code: 'PT'}, 
   {name: 'Puerto Rico', code: 'PR'}, 
   {name: 'Qatar', code: 'QA'}, 
   {name: 'Reunion', code: 'RE'}, 
   {name: 'Romania', code: 'RO'}, 
   {name: 'Russian Federation', code: 'RU'}, 
   {name: 'RWANDA', code: 'RW'}, 
   {name: 'Saint Helena', code: 'SH'}, 
   {name: 'Saint Kitts and Nevis', code: 'KN'}, 
   {name: 'Saint Lucia', code: 'LC'}, 
   {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
   {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
   {name: 'Samoa', code: 'WS'}, 
   {name: 'San Marino', code: 'SM'}, 
   {name: 'Sao Tome and Principe', code: 'ST'}, 
   {name: 'Saudi Arabia', code: 'SA'}, 
   {name: 'Senegal', code: 'SN'}, 
   {name: 'Serbia and Montenegro', code: 'CS'}, 
   {name: 'Seychelles', code: 'SC'}, 
   {name: 'Sierra Leone', code: 'SL'}, 
   {name: 'Singapore', code: 'SG'}, 
   {name: 'Slovakia', code: 'SK'}, 
   {name: 'Slovenia', code: 'SI'}, 
   {name: 'Solomon Islands', code: 'SB'}, 
   {name: 'Somalia', code: 'SO'}, 
   {name: 'South Africa', code: 'ZA'}, 
   {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
   {name: 'Spain', code: 'ES'}, 
   {name: 'Sri Lanka', code: 'LK'}, 
   {name: 'Sudan', code: 'SD'}, 
   {name: 'Suriname', code: 'SR'}, 
   {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
   {name: 'Swaziland', code: 'SZ'}, 
   {name: 'Sweden', code: 'SE'}, 
   {name: 'Switzerland', code: 'CH'}, 
   {name: 'Syrian Arab Republic', code: 'SY'}, 
   {name: 'Taiwan, Province of China', code: 'TW'}, 
   {name: 'Tajikistan', code: 'TJ'}, 
   {name: 'Tanzania, United Republic of', code: 'TZ'}, 
   {name: 'Thailand', code: 'TH'}, 
   {name: 'Timor-Leste', code: 'TL'}, 
   {name: 'Togo', code: 'TG'}, 
   {name: 'Tokelau', code: 'TK'}, 
   {name: 'Tonga', code: 'TO'}, 
   {name: 'Trinidad and Tobago', code: 'TT'}, 
   {name: 'Tunisia', code: 'TN'}, 
   {name: 'Turkey', code: 'TR'}, 
   {name: 'Turkmenistan', code: 'TM'}, 
   {name: 'Turks and Caicos Islands', code: 'TC'}, 
   {name: 'Tuvalu', code: 'TV'}, 
   {name: 'Uganda', code: 'UG'}, 
   {name: 'Ukraine', code: 'UA'}, 
   {name: 'United Arab Emirates', code: 'AE'}, 
   {name: 'United Kingdom', code: 'GB'}, 
   {name: 'United States', code: 'US'}, 
   {name: 'United States Minor Outlying Islands', code: 'UM'}, 
   {name: 'Uruguay', code: 'UY'}, 
   {name: 'Uzbekistan', code: 'UZ'}, 
   {name: 'Vanuatu', code: 'VU'}, 
   {name: 'Venezuela', code: 'VE'}, 
   {name: 'Viet Nam', code: 'VN'}, 
   {name: 'Virgin Islands, British', code: 'VG'}, 
   {name: 'Virgin Islands, U.S.', code: 'VI'}, 
   {name: 'Wallis and Futuna', code: 'WF'}, 
   {name: 'Western Sahara', code: 'EH'}, 
   {name: 'Yemen', code: 'YE'}, 
   {name: 'Zambia', code: 'ZM'}, 
   {name: 'Zimbabwe', code: 'ZW'} 
 ]

const form_data = {
      'first_name': '', 
      'last_name': '', 
      'mobile_no': '', 
      'email': '', 
      'address_1': '',
      'address_2': '',
      'city': '',
      'province': '',
      'appliance_type': '',
      'complaint': '',
      'brand': '',
      'model_no': '',
      'warranty_status': '',
      'serial_no': '',
      'purchased_date': '', 
      'location': '',
      'proof_of_purchase': '',
      'proof_of_purchase_url':'',
      'unit_details': '',
      'unit_details_url':'',
      'unit_defect': '',
      'unit_defect_url':'',
}

const service_schedule = {
      'technician_id': '', 
      'extra_info': '', 
      'schedule_type': 'on-site', 
      'schedule_date': '',
      'assessment': '', 
      'job_description': '', 
      'assessed_date': '', 
      'dealer': '',
      'labor_fee': ''
}

const event_fields = [
      {id: 0, field_id: 1, is_required: 1},
      {id: 0, field_id: 2, is_required: 1},
      {id: 0, field_id: 3, is_required: 1}
]

 const event_restriction_codes = [
   {
       id: 0,
       name: "",
       code: "",
       max_limit: ""
   }
 ]

const profile_data = {
   first_name: "",
   last_name: "",
   birth_date: "",
   gender: "",
   mobile_no: "",
   address: "",
   address1: "",
   address2: "",
   address3: "",
   city: "",
   state: "",
   postal_code: "",
   country: ""
}

const user_data = {
   'employee_id': '', 
   'name': '', 
   'email': '', 
   'password': '',
   'confirm_password': '',
   'status': 1,
   'role_id': ''
}

const employee_data = {
   'branch_id': 1, 
   'first_name': '', 
   'last_name': '', 
   'position': '',
   'status': 1,
}

const gender = [
   {'id': 'male', 'label': 'Male'},
   {'id': 'female', 'label': 'Female'}
]

const service_status = [
   {'id': 'created', 'name': 'New Request'},
   {'id': 'for-assessment', 'name': 'For Assessment'},
   {'id': 'unit-checked', 'name': 'Unit Checked'},
   {'id': 'in-progress', 'name': 'In Progress'},
   {'id': 'repair-completed', 'name': 'Repair Completed'},
   {'id': 'for-release', 'name': 'Ready For Release'},
   {'id': 'completed', 'name': 'Completed'},
   {'id': 'return-to-owner', 'name': 'Return-to-owner'},
   {'id': 'cancelled', 'name': 'Cancelled'},
   {'id': 'available', 'name': 'Parts Status - Available'},
   {'id': 'pending-down-payment', 'name': 'Parts Status - Pending Down Payment'},
   {'id': 'ordered', 'name': 'Parts Status - Ordered'},
   {'id': 'received', 'name': 'Parts Status - Received'},
   {'id': 'price-inquiry', 'name': 'Parts Status - Price Inquiry'}
]

const per_page = 10;

const store = {
   // admin_search_filters,
   // client_search_filters,
   // event_status,
   // timezones,
   // payment_methods,
   
   // event_fields,
   // event_restriction_codes,
   // payment_status,
   // per_page,
   // profile_data,
   // gender,
   // countries,

   form_data,
   employee_data,
   service_schedule,
   user_data,
   service_status
}

export default store